import { Button, Dropdown } from '@beeinventor/dasiot-react-component-lib';
import { DatePicker } from '@mui/x-date-pickers';
import { useQuery } from '@tanstack/react-query';
import { endOfDay } from 'date-fns';
import { useMemo } from 'react';

import { setTaskFilter } from '../../slices/systemSlice';
import { StatusFilterTaskOption } from '../../types';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { getProjects } from '../../apis/projectApi';
import PageHeaderContainer from '../../components/PageHeaderContainer';
import { styled } from '@mui/material';
import { taskGroupPayloadTypeList } from '../../utils/constant';

const ContainerDropdown = styled('div', { label: 'Container-Dropdown' })`
  & div[role='tooltip'] {
    & > .MuiBox-root {
      max-height: 300px;
      overflow: auto;
      & > .Dropdown-item {
        padding: 0px;
        margin: 0px;
        display: flex;
        align-items: center;
        & > div {
          width: 30px;
          min-width: 30px;
        }
        & > span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          flex: 1;
        }
      }
    }
    z-index: 1;
  }
`;

const Header = () => {
  const dispatch = useAppDispatch();
  const { createDate, projectId, taskType } = useAppSelector(
    (store) => store.system.filter.task,
  );

  const { data: projects } = useQuery({
    queryKey: ['get-projects'],
    queryFn: async () => {
      const res = await getProjects();
      if (res.data.data) {
        return res.data.data;
      }
      return [];
    },
    initialData: [],
  });

  const LIST_PROJECT = useMemo(() => {
    if (projects)
      return projects.map((project) => ({
        id: project.id,
        name: project.name,
        value: project.id,
      }));
    return [];
  }, [projects]);

  return (
    <PageHeaderContainer
      sx={{
        '& .divider': {
          width: '2px',
          height: '30px',
          backgroundColor: '#3E3E3E',
        },
      }}
    >
      <ContainerDropdown>
        <Dropdown
          sx={{
            paddingTop: 0,
            paddingBottom: 0,
            width: '200px',
          }}
          selectedId={taskType === 'all' ? undefined : taskType}
          list={taskGroupPayloadTypeList}
          placeholder="Type"
          popperProps={{
            sx: {
              color: '#606060',
            },
            disablePortal: true,
          }}
          onSelect={(v) => {
            dispatch(
              setTaskFilter({
                taskType: v as StatusFilterTaskOption,
              }),
            );
          }}
        />
      </ContainerDropdown>
      <ContainerDropdown>
        <Dropdown
          sx={{
            paddingTop: 0,
            paddingBottom: 0,
            width: '200px',
          }}
          selectedId={projectId}
          list={LIST_PROJECT}
          placeholder="Project"
          popperProps={{
            sx: {
              color: '#606060',
            },
            disablePortal: true,
          }}
          onSelect={(v) => {
            dispatch(
              setTaskFilter({
                projectId: v as string,
              }),
            );
          }}
        />
      </ContainerDropdown>
      <div className="divider"></div>
      <DatePicker
        onChange={(date) => {
          if (date instanceof Date && !isNaN(date.getTime())) {
            dispatch(
              setTaskFilter({
                createDate: endOfDay(date).toISOString(),
              }),
            );
          }
        }}
        value={createDate ? new Date(createDate) : null}
        label="Create Date: YYYY-MM-DD"
        slotProps={{ textField: { size: 'small' } }}
      />
      <Button
        variant="contained"
        color="primary"
        disabled={
          (createDate === '' || createDate === null) &&
          projectId === undefined &&
          taskType === 'all'
        }
        onClick={() => {
          dispatch(
            setTaskFilter({
              createDate: null,
              projectId: undefined,
              taskType: 'all',
            }),
          );
        }}
      >
        Reset
      </Button>
    </PageHeaderContainer>
  );
};

export default Header;
